import { render, staticRenderFns } from "./ApproveFormulationPopUp.vue?vue&type=template&id=0eca481c&scoped=true&"
import script from "./ApproveFormulationPopUp.vue?vue&type=script&lang=js&"
export * from "./ApproveFormulationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ApproveFormulationPopUp.vue?vue&type=style&index=0&id=0eca481c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eca481c",
  null
  
)

export default component.exports